module.exports = __webpack_public_path__ + "img/Luigi-Cutolo.6f14c188.svg";